<div class="cbre-snack-container">
  <span class="cbre-snack-message">
    {{ message }}
  </span>
  <span class="cbre-snack-action" (click)="close()">
    {{ closeText }}
  </span>
</div>
